import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Document extends Base {
  /**
   * @description List Company API function
   * @returns {Promise<Response>}
   */
  list() {
    const url = this._getFullURL("/document");
    return this._secureFetch(url);
  }

  /**
   * @description One Company API function
   * @returns {Promise<Response>}
   */
  getOneCompany(id) {
    const url = this._getFullURL(`/company/${id}`);
    return this._secureFetch(url);
  }

  /**
   * @description Create Location API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  create(payload, fileInput) {
    const url = this._getFullURL("/company/");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("file", fileInput);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Get Location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/company/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Update Location API function
   * @param {string} id
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  update = (id, payload, fileInput) => {
    const url = this._getFullURL(`/company/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    if (fileInput) {
      formdata.append("files", fileInput);
    }

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };

  /**
   * @description Delete machine API function
   * @param {string} uid
   * @returns {Promise<Response>}
   */
  delete = (uid) => {
    const url = this._getFullURL(`/company/${uid}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
